import { DATASTRATEGY, EntityManager } from '@dch/entity-manager';
import { SessionStorageStrategy } from '@dch/entity-manager/lib/storage/strategies/session-storage.strategy';
import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
import { hasUserListed } from '@dch/common-utils';
import * as i1 from '@dch/ng-common/src/lib/environment';

const LUT_ENTITY = {
    version: 'v1',
    disableCache: true,
    url: '/dam/cdn/static/webResources/myPxApp/lutWhiteList_v3.json',
    timeout: 30000,
    dataStrategy: DATASTRATEGY.PROXY_STORAGE,
    storageStrategy: SessionStorageStrategy.ID,
};

class WhitelistService {
    constructor(environmentService) {
        this.environmentService = environmentService;
        this.lutItems = [];
    }
    isWhiteListed(featureName, customerId, msisdn) {
        if (this.environmentService.isLocal || this.environmentService.isItt) {
            return true;
        }
        const lutItem = this.lutItems.find(item => item.featureName === featureName);
        if (lutItem) {
            return lutItem.releaseForWeb || hasUserListed(lutItem, customerId, msisdn);
        }
        return false;
    }
    getWhiteListConfiguration() {
        return EntityManager.getEntity(LUT_ENTITY).pipe(map((lutEntity) => {
            if (lutEntity.value) {
                this.lutItems = lutEntity.value;
                return true;
            }
            return false;
        }));
    }
    /** @nocollapse */ static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: WhitelistService, deps: [{ token: i1.EnvironmentService }], target: i0.ɵɵFactoryTarget.Injectable }); }
    /** @nocollapse */ static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: WhitelistService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "19.0.1", ngImport: i0, type: WhitelistService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: () => [{ type: i1.EnvironmentService }] });

/**
 * Generated bundle index. Do not edit.
 */

export { LUT_ENTITY, WhitelistService };
